import { Suspense, lazy } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.scss";
import Loader from "./components/Loader/Loader";
import { AuthCheckProvider } from "./context/AuthCheckProvider";
import { HeaderTabProvider } from "./context/HeaderTabProvider";
import { SnackBarProvider } from "./context/SnackBarProvider";

// Route-level code splitting: each page loads only when visited,
// keeping the initial bundle small for a fast first paint.
const Login = lazy(() => import("./pages/SharedComponents/Login/Login"));
const ForgotPassword = lazy(
  () => import("./pages/SharedComponents/ForgotPassword/ForgotPassword")
);
const AuthorizedRoutes = lazy(() => import("./Routes/AuthorizedRoutes"));

function App() {
  return (
    <AuthCheckProvider>
      <Router>
        <SnackBarProvider>
          <HeaderTabProvider>
            <Suspense fallback={<Loader />}>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route element={<AuthorizedRoutes />} path="*" />
              </Routes>
            </Suspense>
          </HeaderTabProvider>
        </SnackBarProvider>
      </Router>
    </AuthCheckProvider>
  );
}

export default App;
